import { render, staticRenderFns } from "./addalbum.vue?vue&type=template&id=66104316&scoped=true&"
import script from "./addalbum.vue?vue&type=script&lang=js&"
export * from "./addalbum.vue?vue&type=script&lang=js&"
import style0 from "./addalbum.vue?vue&type=style&index=0&id=66104316&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66104316",
  null
  
)

export default component.exports